/* searchOptions for fuse */
export const endpointListSearchOptions = {
  threshold: 0.1,
  keys: [
    'path'
  ]
};
